import { Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { Trans, useTranslation } from 'react-i18next';
import { rawUserDetailsAtom } from '@/atoms/queries/user';

const getFirstName = (name: string) => name.trim().split(/\s+/)[0];

export const HomeGreeting = () => {
  const { t } = useTranslation('home');
  const firstName = getFirstName(useAtomValue(rawUserDetailsAtom).data.user.name);

  return (
    <Typography as="h2" variant="displayRegular">
      {firstName ? (
        <Trans t={t} i18nKey="greeting" values={{ firstName }} components={{ bold: <strong /> }} />
      ) : (
        t('greetingNoName')
      )}
    </Typography>
  );
};
